import { confirmAlert } from 'react-confirm-alert';
import React from 'react';
import Constants from './Constants';

class CommonUtils {
    static mainSiteTitle = 'Careermon';

    static displayDefaultConfirmAlertWithMessage(message, navigate, t, onClick) {
        CommonUtils.displayConfirmAlert(message, {
            label: t('button.ok'),
            className: 'btn-secondary',
            onClick: onClick || (() => navigate('/'))
        });
    }

    static displayDefaultConfirmAlert(navigate, t, onClick) {
        CommonUtils.displayConfirmAlert(undefined, {
            label: t('button.ok'),
            className: 'btn-secondary',
            onClick: onClick || (() => navigate('/'))
        });
    }

    static displayConfirmAlert(
        message = "You don't have right to access this page",
        okOption = {
            label: 'Close',
            className: 'btn-secondary',
            onClick: () => {}
        },
        cancelOption = null,
        title = 'Sign in',
        height = '180px',
        classNameWrap = '',
        classNameBody = ''
    ) {
        confirmAlert({
            closeOnClickOutside: false,
            customUI: ({ onClose }) => {
                return (
                    <div className={`custom-leave-alert ${classNameWrap}`}>
                        <div style={{ minHeight: height }} className={`react-confirm-alert-body ${classNameBody}`}>
                            <div className="content">
                                <h1>{title}</h1>
                                <p dangerouslySetInnerHTML={{ __html: message }} />
                            </div>
                            <div className="react-confirm-alert-button-group">
                                {cancelOption && (
                                    <button
                                        onClick={() => {
                                            if (cancelOption.onClick) {
                                                cancelOption.onClick();
                                            }
                                            onClose();
                                        }}
                                        className="btn btn-link"
                                    >
                                        {cancelOption.label}
                                    </button>
                                )}
                                <button
                                    onClick={() => {
                                        if (okOption.onClick) {
                                            okOption.onClick();
                                        }
                                        onClose();
                                    }}
                                    className={`btn btn-link btn-secondary ${okOption.className}`}
                                >
                                    {okOption.label}
                                </button>
                            </div>
                        </div>
                    </div>
                );
            }
        });
    }

    static displayConfirmDenyAlert(
        message = "You don't have right to access this page",
        okOption = {
            label: 'Close',
            className: 'btn-secondary',
            onClick: () => {}
        },
        cancelOption = null,
        title = 'Sign in',
        height = '180px'
    ) {
        confirmAlert({
            closeOnClickOutside: false,
            customUI: ({ onClose }) => {
                return (
                    <div className="custom-confirm-deny-alert">
                        <div style={{ minHeight: height }} className="react-confirm-alert-body">
                            <div className="content">
                                <div className="d-flex">
                                    <h1 className="flex-grow-1">{title}</h1>
                                    <span onClick={() => onClose()}>&times;</span>
                                </div>
                                <p dangerouslySetInnerHTML={{ __html: message }} />
                            </div>
                            <div className="react-confirm-alert-button-group">
                                {cancelOption && (
                                    <button
                                        onClick={() => {
                                            if (cancelOption.onClick) {
                                                cancelOption.onClick();
                                            }
                                            onClose();
                                        }}
                                        className="btn btn-link"
                                    >
                                        {cancelOption.label}
                                    </button>
                                )}
                                <button
                                    onClick={() => {
                                        if (okOption.onClick) {
                                            okOption.onClick();
                                        }
                                        onClose();
                                    }}
                                    className={`btn btn-save-confirm ${okOption.className}`}
                                >
                                    {okOption.label}
                                </button>
                            </div>
                        </div>
                    </div>
                );
            }
        });
    }

    static displayConfirmSubmit(
        message = "You don't have right to access this page",
        okOption = {
            label: 'Close',
            className: 'btn-secondary',
            onClick: () => {}
        },
        height = '180px'
    ) {
        confirmAlert({
            closeOnClickOutside: false,
            customUI: ({ onClose }) => {
                return (
                    <div className="confirm-submit-alert">
                        <div style={{ minHeight: height }} className="react-confirm-alert-body">
                            <div className="content">
                                <p dangerouslySetInnerHTML={{ __html: message }} />
                            </div>
                            <span
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    onClose();
                                }}
                                className="confirm-btn-close"
                            />
                            <div className="react-confirm-alert-button-group">
                                <button
                                    onClick={() => {
                                        onClose();
                                    }}
                                    className="btn btn-link"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={() => {
                                        if (okOption.onClick) {
                                            okOption.onClick();
                                        }
                                        onClose();
                                    }}
                                    className={`btn btn-save-confirm ${okOption.className}`}
                                >
                                    {okOption.label}
                                </button>
                            </div>
                        </div>
                    </div>
                );
            }
        });
    }

    static confirmDiscardForm(message, onDiscard, cancelLabel = 'Cancel', okLabel = 'Discard') {
        confirmAlert({
            closeOnClickOutside: false,
            customUI: ({ onClose }) => {
                return (
                    <div className="narrow-modal common-warning-modal">
                        <div className="react-confirm-alert-body">
                            <div className="warning-box">
                                <p>{message}</p>
                            </div>
                            <div className="react-confirm-alert-button-group">
                                <button onClick={onClose} className="btn btn-link btn-secondary">
                                    {cancelLabel}
                                </button>
                                <button
                                    onClick={(event) => {
                                        onDiscard();
                                        onClose();
                                    }}
                                    className="btn btn-link"
                                >
                                    {okLabel}
                                </button>
                            </div>
                        </div>
                    </div>
                );
            }
        });
    }

    static basicInform(message = '', okTitle = 'OK') {
        confirmAlert({
            closeOnClickOutside: false,
            customUI: ({ onClose }) => {
                return (
                    <div id="react-confirm-alert">
                        <div className="react-confirm-alert-overlay">
                            <div className="react-confirm-alert">
                                <div className="narrow-modal common-warning-modal">
                                    <div className="react-confirm-alert-body mobile-modal">
                                        <div className="warning-box">
                                            <p>{message}</p>
                                        </div>
                                        <div className="react-confirm-alert-button-group">
                                            <button
                                                className="btn"
                                                onClick={() => {
                                                    onClose();
                                                }}
                                                label="OK"
                                            >
                                                {okTitle}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
        });
    }

    static useClickOutside(ref, onClickOutside) {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                onClickOutside(event);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }

    static getDefaultAvatar(name) {
        let firstTwoCharsOfName = 'CM';
        if (name?.length > 1) {
            firstTwoCharsOfName = name.slice(0, 2);
        }
        return firstTwoCharsOfName.toUpperCase();
    }

    static handleFormKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault(); // Prevent Enter key press from submitting the form
        }
    };

    /**
     * Sorting based on following priority:
     * * First - (Status): Leader > Sub_Leader > Employee > Resigned
     * * Second - (Department Level): Level 1 > Level 2 > Level 3
     * * Third - (Alphabet of Name)
     * */
    static sortEmployeeList = (employeeList) => {
        return employeeList?.sort((a, b) => {
            if (
                (a.data.status === Constants.HR_CARD.STATUS.LEADER && (b.data.status === Constants.HR_CARD.STATUS.SUB_LEADER || b.data.status === Constants.HR_CARD.STATUS.EMPLOYEE || b.data.status === Constants.HR_CARD.STATUS.RESIGNED)) ||
                (a.data.status === Constants.HR_CARD.STATUS.SUB_LEADER && (b.data.status === Constants.HR_CARD.STATUS.EMPLOYEE || b.data.status === Constants.HR_CARD.STATUS.RESIGNED)) ||
                (a.data.status === Constants.HR_CARD.STATUS.EMPLOYEE && b.data.status === Constants.HR_CARD.STATUS.RESIGNED)
            ) {
                return -1;
            } else if (
                (a.data.status === Constants.HR_CARD.STATUS.SUB_LEADER && b.data.status === Constants.HR_CARD.STATUS.LEADER) ||
                (a.data.status === Constants.HR_CARD.STATUS.EMPLOYEE && (b.data.status === Constants.HR_CARD.STATUS.SUB_LEADER || b.data.status === Constants.HR_CARD.STATUS.LEADER)) ||
                (a.data.status === Constants.HR_CARD.STATUS.RESIGNED && (b.data.status === Constants.HR_CARD.STATUS.EMPLOYEE || b.data.status === Constants.HR_CARD.STATUS.SUB_LEADER || b.data.status === Constants.HR_CARD.STATUS.LEADER))
            ) {
                return 1;
            } else {
                if (a.data.level < b.data.level) {
                    return -1;
                } else if (a.data.level > b.data.level) {
                    return 1;
                } else {
                    if (a.data.name < b.data.name) {
                        return -1;
                    } else if (a.data.name > b.data.name) {
                        return 1;
                    } else {
                        return 0;
                    }
                }
            }
        });
    };

    static resizeImage = (file, maxWidth) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (event) => {
                const img = new Image();

                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const scaleFactor = maxWidth / img.width;
                    const width = maxWidth;
                    const height = img.height * scaleFactor;

                    canvas.width = width;
                    canvas.height = height;

                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, height);

                    canvas.toBlob(
                        (blob) => {
                            const resizedFile = new File([blob], file.name, { type: file.type });
                            resolve(resizedFile);
                        },
                        file.type,
                        1
                    );
                };

                img.onerror = (error) => {
                    reject(error);
                };

                img.src = event.target.result;
            };

            reader.onerror = (error) => {
                reject(error);
            };

            reader.readAsDataURL(file);
        });
    };
}

export default CommonUtils;
